import React, { FunctionComponent } from 'react'
import { G, Path, Rect, Svg } from 'react-native-svg'

export const SideNavCaseloadIcon: FunctionComponent<SideNavCaseloadIconProps> = ({
  size = 32,
  fillColor,
  isFilled = true,
}) => {
  return (
    <Svg width={size} height={size} fill='none'>
      {isFilled ? (
        <Path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.43636 4.30453C3.10938 4.94627 3.10938 5.78634 3.10938 7.4665V24.5332C3.10938 26.2133 3.10938 27.0534 3.43636 27.6951C3.72398 28.2596 4.18292 28.7186 4.7474 29.0062C5.38914 29.3332 6.22922 29.3332 7.90937 29.3332H24.976C26.6562 29.3332 27.4963 29.3332 28.138 29.0062C28.7025 28.7186 29.1614 28.2596 29.4491 27.6951C29.776 27.0534 29.776 26.2133 29.776 24.5332V7.4665C29.776 5.78635 29.776 4.94627 29.4491 4.30453C29.1614 3.74005 28.7025 3.2811 28.138 2.99348C27.4963 2.6665 26.6562 2.6665 24.976 2.6665H7.90938C6.22922 2.6665 5.38914 2.6665 4.7474 2.99348C4.18292 3.2811 3.72398 3.74005 3.43636 4.30453ZM17.777 10.6665C17.777 9.93312 17.177 9.33312 16.4437 9.33312C15.7104 9.33312 15.1104 9.93312 15.1104 10.6665V21.3331C15.1104 22.0665 15.7104 22.6665 16.4437 22.6665C17.177 22.6665 17.777 22.0665 17.777 21.3331V10.6665ZM11.3002 13.3331H11.1097C10.3764 13.3331 9.77637 13.9331 9.77637 14.6665V21.3331C9.77637 22.0665 10.3764 22.6665 11.1097 22.6665H11.3002C12.0335 22.6665 12.6335 22.0665 12.6335 21.3331V14.6665C12.6335 13.9331 12.0335 13.3331 11.3002 13.3331ZM21.7757 16.9523C22.509 16.9523 23.109 17.5523 23.109 18.2856V21.3332C23.109 22.0666 22.509 22.6665 21.7757 22.6665C21.0424 22.6665 20.4424 22.0666 20.4424 21.3332V18.2856C20.4424 17.5523 21.0424 16.9523 21.7757 16.9523Z'
          fill={fillColor}
        />
      ) : (
        <G>
          <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.0051 9.33312C16.7384 9.33312 17.3384 9.93312 17.3384 10.6665V21.3331C17.3384 22.0665 16.7384 22.6665 16.0051 22.6665C15.2718 22.6665 14.6718 22.0665 14.6718 21.3331V10.6665C14.6718 9.93312 15.2718 9.33312 16.0051 9.33312ZM10.6691 13.3331H10.8596C11.593 13.3331 12.193 13.9331 12.193 14.6665V21.3331C12.193 22.0665 11.593 22.6665 10.8596 22.6665H10.6691C9.93582 22.6665 9.33582 22.0665 9.33582 21.3331V14.6665C9.33582 13.9331 9.93582 13.3331 10.6691 13.3331ZM22.6665 18.2856C22.6665 17.5523 22.0665 16.9523 21.3332 16.9523C20.5999 16.9523 19.9999 17.5523 19.9999 18.2856V21.3332C19.9999 22.0665 20.5999 22.6665 21.3332 22.6665C22.0665 22.6665 22.6665 22.0665 22.6665 21.3332V18.2856Z'
            fill={fillColor}
          />
          <Rect x='3.66797' y='3.6665' width='24.6667' height='24.6667' rx='2' stroke={fillColor} stroke-width='2' />
        </G>
      )}
    </Svg>
  )
}

export type SideNavCaseloadIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}
